export enum CartTracingMessages {
  CAPABILITY = 'orders',
  CHANGE_QUANTITY = 'Add To Order',
  CHANGE_PO = 'Add PO / Change PO',
  CHANGE_DELIVERY_DATE = 'Change Delivery Date',
}
